import * as actionTypes from './actionMenuActionTypes';

export const setActionMenuAnchorEl = (anchorEl) => ({type: actionTypes.SET_ACTION_MENU_ANCHOR_EL, anchorEl: anchorEl});
export const setActionMenuPlacement = (placement) => ({type: actionTypes.SET_ACTION_MENU_PLACEMENT, placement: placement});
export const setActionMenuOpen = (open) => ({type: actionTypes.SET_ACTION_MENU_OPEN, open: open});
export const setActionMenuId = (id) => ({type: actionTypes.SET_ACTION_MENU_ID, id: id});



